module.exports = __webpack_public_path__ + "img/phone-call.81409dd3.svg";